import React from "react"
import { Button } from "letalkui"
import { Grid, Typography } from "@material-ui/core"
import { Portlet } from "@/components"
import { Add as AddIcon } from "@material-ui/icons"

import CreateAgentDialog from "@/pages/Admin/Agent/AgentList/CreateAgentDialog"

import useStyles from "@/pages/Admin/Agent/AgentList/EmptyAgentList/styles"

const EmptyAgentList: React.FC = () => {
	const classes = useStyles()

	return (
		<Portlet elevation={1} style={{ padding: "36px", boxShadow: "none" }}>
			<Grid container justifyContent="center" alignItems="center">
				<Grid item alignItems="center" className={classes.item}>
					<Grid container spacing={2} justifyContent="center" alignItems="center">
						<Grid item>
							<Typography variant="h4" className={classes.text}>
								Nenhum agente cadastrado 😥
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body1" className={classes.description}>
								Você ainda não transformou seu atendimento com nossos Agentes de IA. Que tal criar um agora mesmo?!
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Grid container justifyContent="center">
								<CreateAgentDialog>
									<Button.Primary
										size="small"
										startIcon={<AddIcon />}
									>
										Adicionar Agente
									</Button.Primary>
								</CreateAgentDialog>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default EmptyAgentList
